/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Teamcount1Inputs */

const en_entity_teamcount1 = /** @type {(inputs: Entity_Teamcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team Count`)
};

const de_entity_teamcount1 = /** @type {(inputs: Entity_Teamcount1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anzahl Teams`)
};

/**
* | output |
* | --- |
* | "Team Count" |
*
* @param {Entity_Teamcount1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_teamcount1 = /** @type {((inputs?: Entity_Teamcount1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Teamcount1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_teamcount1(inputs)
	return de_entity_teamcount1(inputs)
});
export { entity_teamcount1 as "entity_teamCount" }